import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TransportManagementProfileFilterModel } from '../../transport-management/models';
import {
  ProfileSubscription,
  ProfileSubscriptionForm,
  TransportManagementProfileReport,
  TransportManagementProfileReportForm,
} from '../../../../models';
import { PlannerProfileType } from '../../../../constants/planner-profile.constant';
import { mustNotBeBlankValidator } from '../../../../../common/utils';

export class TransportManagementProfileDetails {
  id?: number;
  createdBy?: number;
  createdByEmail?: string;
  name: string;
  description: string;
  type: PlannerProfileType = PlannerProfileType.Public;
  subscription: Partial<ProfileSubscription> = new ProfileSubscription();
  report: Partial<TransportManagementProfileReport> = new TransportManagementProfileReport();
  isDefault = false;

  constructor(params?: Partial<TransportManagementProfileDetails>) {
    if (params) {
      Object.assign(this, params);
      if (!params.subscription) {
        this.subscription = new ProfileSubscription();
      }
    }
  }
}

export class TransportManagementProfileModel extends TransportManagementProfileDetails {
  filter: TransportManagementProfileFilterModel = new TransportManagementProfileFilterModel();

  constructor(params?: TransportManagementProfileModel) {
    super();
    if (params) {
      Object.assign(this, params);
      this.filter = new TransportManagementProfileFilterModel(params.filter);
    }
  }
}

export class TransportManagementProfileDetailsForm {
  id?: FormControl<number>;
  createdBy?: FormControl<number>;
  createdByEmail?: FormControl<string>;
  constructor(
    model: TransportManagementProfileDetails,
    fb: FormBuilder = new FormBuilder(),
    public subscription: FormGroup<ProfileSubscriptionForm> = fb.group<ProfileSubscriptionForm>(
      new ProfileSubscriptionForm(model.subscription),
    ),
    public report: FormGroup<TransportManagementProfileReportForm> = fb.group<TransportManagementProfileReportForm>(
      new TransportManagementProfileReportForm(model.report),
    ),
    public name: FormControl<string> = fb.control<string>(model.name, [Validators.required, mustNotBeBlankValidator]),
    public description: FormControl<string> = fb.control<string>(model.description, []),
    public type: FormControl<PlannerProfileType> = fb.control<PlannerProfileType>(model.type, [Validators.required]),
    public isDefault: FormControl<boolean> = fb.control<boolean>(model.isDefault, []),
  ) {
    if (model.id) {
      this.id = fb.control<number>(model.id, []);
    }
    if (model.createdBy) {
      this.createdBy = fb.control<number>(model.createdBy, []);
    }
    if (model.createdByEmail) {
      this.createdByEmail = fb.control<string>(model.createdByEmail, []);
    }
  }
}
